import React from "react";
import {
  Container,
  Grid,
} from "@material-ui/core";
import CardParents from "./CardParents";
import NewParent from "./NewParent";
import { useRole } from "../../hooks/useRole";

export default function Parents() {
  const { isAdmin } = useRole();
  return (
    <Container maxWidth="lg">
      <Grid container spacing={1}>
        <Grid item sm={isAdmin ? 6 : 12} xs={12}>
          <CardParents />
        </Grid>
        {isAdmin && (
          <Grid item sm={6} xs={12}>
            <NewParent />
          </Grid>
        )}
      </Grid>
    </Container>
  );
}
